import Activity, {
  ActivityOptions,
  ActivityType,
  BaseActivityData,
  BaseActivityDataOptions,
  getDefaults as getActivityDefaults,
} from 'models/Activity';
import Group, { GroupOptions } from 'models/Group';

export interface ServiceRefusalOptions extends ActivityOptions {
  type: ActivityType.SERVICE_REFUSAL;
  data: Partial<
    BaseActivityDataOptions & {
      reassignedTo: Partial<GroupOptions> | null;
      refusedBy: Partial<GroupOptions> | null;
    }
  >;
}

export function getDefaults(): ServiceRefusalOptions {
  return {
    ...getActivityDefaults(),
    type: ActivityType.SERVICE_REFUSAL,
    data: {
      ...getActivityDefaults().data,
      reassignedTo: null,
      refusedBy: null,
    },
  };
}

export default class ServiceRefusal extends Activity {
  declare type: ActivityType.SERVICE_REFUSAL;
  declare data: BaseActivityData & {
    reassignedTo: Group | null;
    refusedBy: Group | null;
  };

  constructor(options: Partial<ServiceRefusalOptions> = {}) {
    const opts = { ...getDefaults(), ...options };

    super(opts);

    this.data = {
      ...this.data,
      reassignedTo: opts.data.reassignedTo ? new Group(opts.data.reassignedTo) : null,
      refusedBy: opts.data.refusedBy ? new Group(opts.data.refusedBy) : null,
    };
  }

  get typeLabel() {
    return 'Service Refusal Update';
  }
}
